import { useEffect, useState } from 'react';
import { anagrafiche, type UnitaMisuraMago } from '../../api/acquisti';

/*  L'ELENCO DELLE UNITA' DI MISURA, chiesto una volta sola per sessione.

    Serve a ogni riga d'articolo di ogni preventivo aperto, e una riga non ha modo di
    sapere se la riga accanto l'ha già chiesto. Senza questa cache un preventivo da
    ottanta voci farebbe ottanta chiamate identiche nel momento peggiore — mentre si
    apre la scheda — per un elenco di quattordici parole che non cambia mai durante una
    giornata di lavoro.

    Si tiene la PROMESSA e non il risultato: due righe che montano nello stesso istante
    trovano la stessa richiesta in volo invece di farne due. Una richiesta fallita si
    dimentica, così la volta dopo si riprova: un'anagrafica irraggiungibile per dieci
    secondi non deve lasciare la tendina vuota fino al ricarico della pagina.  */
let inVolo: Promise<UnitaMisuraMago[]> | null = null;

export function unitaDiMisura(): Promise<UnitaMisuraMago[]> {
  inVolo ??= anagrafiche.unitaMisura().catch((errore) => {
    inVolo = null;
    throw errore;
  });

  return inVolo;
}

/** Solo per le prove: rimette l'elenco al «non l'ho ancora chiesto». */
export function dimenticaUnitaDiMisura(): void {
  inVolo = null;
}

/*  L'elenco per chi disegna. Parte vuoto e resta vuoto se Mago non risponde: il campo
    dell'unità è testo libero con dei suggerimenti, quindi senza suggerimenti si scrive
    lo stesso. Un'anagrafica giù non deve impedire di battere «PZ».  */
export function useUnitaDiMisura(): UnitaMisuraMago[] {
  const [unita, setUnita] = useState<UnitaMisuraMago[]>([]);

  useEffect(() => {
    let vivo = true;
    unitaDiMisura()
      .then((lette) => {
        if (vivo) setUnita(lette);
      })
      .catch(() => {
        /* niente suggerimenti: il campo resta scrivibile */
      });

    return () => {
      vivo = false;
    };
  }, []);

  return unita;
}
